module.exports = __webpack_public_path__ + "img/log-3.ce4bf477.png";